import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { PluginInjectorWidget } from "core-client/api";
import { SharedModule } from "../../../shared/shared.module";

@Component({
  selector: "app-widget-window-placeholder",
  imports: [SharedModule],
  templateUrl: "./widget-window-placeholder.component.html",
  styleUrl: "./widget-window-placeholder.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WidgetWindowPlaceholderComponent {
  @Input({ required: true })
  widget!: PluginInjectorWidget.IWidget;

  @Output()
  readonly focusRequest: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  readonly bringBackRequest: EventEmitter<void> = new EventEmitter<void>();

  get title(): string {
    return `${this.widget.name}${this.widget.extraTitle ?? ""}`;
  }
}
